import { render, staticRenderFns } from "./TermOfRunRun.vue?vue&type=template&id=2f706cd0&"
import script from "./TermOfRunRun.vue?vue&type=script&lang=js&"
export * from "./TermOfRunRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports